import useCommonStoreInfoQuery from "@repo/shopify/queries/useStoreInfoQuery";

import { useLayoutStore } from "@store/layout";

export default function useStoreInfo() {
  const { openToast } = useLayoutStore();

  return useCommonStoreInfoQuery({
    lang: "ko",
    openToast,
  });
}
